import React from 'react';
import PropTypes from 'prop-types';
import styles from './button.module.scss';

const Button = ({
  children,
  type,
  isLoading,
  handleClick,
  className,
  isDisabled = false,
}) => (
    <button type="button" onClick={handleClick} className={`${styles.button} ${className || ''} ${isDisabled ? styles.disabled : ''} ${styles[type]} ${isLoading ? styles.loading : ''}`}>
      {children}
    </button>
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  type: PropTypes.string,
  isLoading: PropTypes.bool,
  handleClick: PropTypes.func,
  isDisabled: PropTypes.bool,
};

Button.defaultProps = {
  type: 'primary',
  isLoading: false,
  handleClick: () => {},
};

export default Button;
